import { InputTag } from 'mixs/base/input_mixin';
type ItemType = {
  order_id: string,
  job_no: string
}
import {
  PLANNER_CLICK_PIN
} from 'apps/events';
export class SearchComma extends InputTag {
  jobnos: ItemType[] = [];
  public init() {
    super.init();
    this.watch();
  }
  onClickJobno(e){
    let order_id = e.currentTarget.dataset.id
    let customEvent = new CustomEvent(PLANNER_CLICK_PIN, { detail: order_id })
    document.dispatchEvent(customEvent);
  }
  onSelect(order_id:string|number, element: HTMLElement){
    // order_id, element.textContent
    let newVal = {}
    newVal["order_" + order_id] = { job_no: element.textContent }
    let dispatch = App.store.dispatch;
    let planner = App.actions.planner;
    dispatch(planner.orders(newVal))
    let customEvent = new CustomEvent(PLANNER_CLICK_PIN, { detail: order_id })
    document.dispatchEvent(customEvent);
  }
}

riot.mixin('inputs.complex.search-comma', SearchComma as riot.TagMixin)
